import { render, staticRenderFns } from "./NoDataBookMarkedLesson.vue?vue&type=template&id=80106d70&scoped=true&"
import script from "./NoDataBookMarkedLesson.vue?vue&type=script&lang=js&"
export * from "./NoDataBookMarkedLesson.vue?vue&type=script&lang=js&"
import style0 from "./NoDataBookMarkedLesson.vue?vue&type=style&index=0&id=80106d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80106d70",
  null
  
)

export default component.exports